export default __webpack_public_path__ + "static/media/newblp_Workspaces_sel.abb7e28a.svg";